import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const Footer = (props) => {
  const navigate = useNavigate();
  return (
    <footer className='py-5 bg-dark text-white'>
          <Container>
            <Row className='align-items-center'>
              <Col md={6} className='mb-4 mb-md-0'>
                <h3 className='fw-bold mb-3'>
                  <span className='text-warning'>MBOX</span> Express
                </h3>
                <p className='text-white-50 mb-0'>
                  Tu solución confiable para envíos internacionales desde Miami
                  a Honduras.
                </p>
              </Col>
              <Col md={6} className='text-md-end'>
                <div className='d-flex justify-content-md-end gap-3'>
                  <a
                    href='#'
                    className='text-white-50 hover-white text-decoration-none'
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.scrollTo(0, 0);
                      navigate("/terminos-y-condiciones", { replace: true });
                    }}
                  >
                    Términos y Condiciones
                  </a>
                  <a
                    href='#'
                    style={{ cursor: "pointer" }}
                    className='text-white-50 hover-white text-decoration-none ms-3'
                    onClick={(e) => {
                      e.preventDefault();
                      window.scrollTo(0, 0);
                      navigate("/politicas-de-privacidad", { replace: true });
                    }}
                  >
                    Politicas de Privacidad
                  </a>
                  <a
                    href='#'
                    className='text-white-50 hover-white text-decoration-none ms-3'
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.scrollTo(0, 0);
                      navigate("/FAQ", { replace: true });
                    }}
                  >
                    FAQ
                  </a>
                </div>
                <p className='text-white-50 mt-3 mb-0'>
                  © {new Date().getFullYear()} MBOX Express. Todos los derechos
                  reservados.
                </p>
              </Col>
            </Row>
          </Container>
        </footer>
  );
};

export default Footer;
